import React from 'react';
import { connect } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import { login, fetchUserInfo } from './actions';

const LoginPage = props => {
    const { user, isActive } = props;
    const location = useLocation();
    const history = useHistory();
    let { from } = location.state || { from: { pathname: "/" } };
    
    if (!user) {
        return (
            <div className="col-xs-12 text-center" style={{ marginTop: '150px' }}>
                <p>You must log in to view the page at {from.pathname}</p>
                <button onClick={() => login(props.dispatch, from)}>Log In</button>
            </div>
        );
    }

    if (!isActive) {
        return (
            <div className="col-xs-12 text-center" style={{ marginTop: '150px' }}>
                <p>You have successfully authenticated, but your account is not active for Salesforce or lacks permissions for the page at {from.pathname}</p>
                <button onClick={() => props.dispatch(fetchUserInfo)}>Re-Check Status</button>
            </div>
        );
    }

    setTimeout(() => history.replace(from.pathname),50);

    return (
        <div className="col-xs-12 text-center" style={{ marginTop: '150px' }}>
            <p>You have successfully authenticated.</p>
            <button onClick={() => history.replace(from.pathname)}>Return to {from.pathname}</button>
        </div>
    );
}

const mapStateToProps = state => ({
    user: state.oidc.user,
    isActive: state.userManager.isActive
});

export default connect(mapStateToProps)(LoginPage)